import type { Attempt, AttemptStatus } from "../types"

export const ATTEMPT_STATUS_CONFIG: Record<
  AttemptStatus,
  { label: string; className: string }
> = {
  draft: {
    label: "In Progress",
    className: "is-draft",
  },
  marking: {
    label: "AI Marking",
    className: "is-marking",
  },
  marked: {
    label: "Marked",
    className: "is-marked",
  },
  submitted: {
    label: "Completed",
    className: "is-submitted",
  },
  flagged_for_review: {
    label: "Flagged",
    className: "is-flagged",
  },
  failed: {
    label: "Marking failed",
    className: "is-submitted",
  },
}

export const attemptDropdownLabel = (attempt: Attempt): string => {
  switch (attempt.status) {
    case "draft":
      return `Attempt ${attempt.attemptNumber} — In Progress`
    case "marking":
      return `Attempt ${attempt.attemptNumber} — AI Marking…`
    case "marked":
      return `Attempt ${attempt.attemptNumber} — ${attempt.score}/${attempt.maxScore} marks`
    case "submitted":
      return `Attempt ${attempt.attemptNumber} — Completed (no AI)`
    case "flagged_for_review":
      return `Attempt ${attempt.attemptNumber} — Flagged${
        attempt.score !== null && attempt.maxScore !== null
          ? ` (${attempt.score}/${attempt.maxScore})`
          : ""
      }`
    case "failed":
      return `Attempt ${attempt.attemptNumber} — Marking failed`
    default:
      return `Attempt ${attempt.attemptNumber}`
  }
}

export const isTerminalAttempt = (status: AttemptStatus) =>
  status === "marked" ||
  status === "submitted" ||
  status === "flagged_for_review" ||
  status === "failed"
